import React from 'react';
import {AppFormLayout,AppForm,AppFormPageProps,AppFormItemEnum} from 'qcc'
import {appEnum} from 'utils/appEnum'

const options = [{label:'选项1',value:'选项1'},{label:'选项2',value:'选项2'}]
export default class PosBankSetForm extends React.PureComponent<AppFormPageProps> {
    state = {}
    
	render() {
		let {formData,mode,id} = this.props;
		return (<AppFormLayout defaultButton mode={this.props.mode}>
            <AppFormLayout.Form>
                <AppForm entity='pos_device' loadingData={false} mode={mode} keyValue={id} formData={formData} >
                    <AppForm.Section labelWidth={100}>
						<AppForm.Item itemType={AppFormItemEnum.hidden} field='project_id' dataType={appEnum.dataType.number} />
                        <AppForm.Item field='bank_name' itemType={AppFormItemEnum.input} label="入账银行" req readonly={true}  />
						<AppForm.Item field='fund' itemType={AppFormItemEnum.select} label="款项名称" req  options={options}/>
                        <AppForm.Item field='ld_name' itemType={AppFormItemEnum.select} label="对应楼栋" req  options={options} />
                    </AppForm.Section>
                </AppForm>
            </AppFormLayout.Form>
        </AppFormLayout>
	    )
	}

}


// WEBPACK FOOTER //
// ./src/page/pos/bank/PosBankSetForm.tsx